import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import FormRenderer from '../shared/FormRenderer';
import StudentFormsModal from './StudentFormsModal';
import '../superadmin/DistrictsList.css';
import './ViewStudents.css';

const ViewStudents = () => {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showFormsModal, setShowFormsModal] = useState(false);
  const [formsModalStudent, setFormsModalStudent] = useState(null);

  useEffect(() => {
    fetchStudents();
  }, []);

  const fetchStudents = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/student-intake/district');
      setStudents(response.data);
    } catch (error) {
      console.error('Failed to fetch students:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleViewStudent = async (studentId) => {
    try {
      const response = await axios.get(`/api/student-intake/district/${studentId}`);
      setSelectedStudent(response.data);
    } catch (error) {
      console.error('Failed to fetch student details:', error);
      alert('Failed to load student details');
    }
  };

  const handleSoftDelete = async (studentId) => {
    if (!window.confirm('Are you sure you want to delete this student record? This action cannot be undone.')) {
      return;
    }

    try {
      await axios.delete(`/api/student-intake/district/${studentId}`);
      // Refresh the list
      fetchStudents();
      setSelectedStudent(null);
    } catch (error) {
      console.error('Failed to delete student:', error);
      alert('Failed to delete student record');
    }
  };

  const renderStudentDetails = (student) => {
    return (
      <div>
        <h4>Student Information:</h4>
        <div style={{ background: '#f5f5f5', padding: '1rem', borderRadius: '4px' }}>
          <p><strong>Name:</strong> {student.last_name}, {student.first_name}</p>
          <p><strong>Date of Birth:</strong> {student.date_of_birth ? new Date(student.date_of_birth).toLocaleDateString() : 'Not provided'}</p>
          <p><strong>Age:</strong> {student.age || 'Not calculated'}</p>
          <p><strong>Last 4 SSN:</strong> {student.last_4_ssn || 'Not provided'}</p>
          <p><strong>Parent:</strong> {student.parent_first_name} {student.parent_last_name}</p>
          <p><strong>Parent Email:</strong> {student.parent_email}</p>
          <p><strong>Created:</strong> {new Date(student.created_at).toLocaleString()}</p>
        </div>
      </div>
    );
  };

  if (loading && students.length === 0) {
    return <div>Loading...</div>;
  }

  return (
    <div className="districts-list">
      <div className="page-header">
        <h2>Students</h2>
        <p style={{ fontSize: '0.9em', color: '#666', marginTop: '0.5rem' }}>
          View all student intake records for your district. Click "View Forms" to see completed forms for each student.
        </p>
      </div>

      {/* Student Modal */}
      {selectedStudent && (
        <div className="modal-overlay" onClick={() => setSelectedStudent(null)}>
          <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px', width: '90%', maxHeight: '80vh', overflowY: 'auto' }}>
            <div className="modal-header">
              <h3>Student Intake Information</h3>
              <button onClick={() => setSelectedStudent(null)} className="btn-close">&times;</button>
            </div>
            <div className="modal-body">
              {renderStudentDetails(selectedStudent)}
            </div>
            <div className="modal-actions">
              <button
                onClick={() => handleSoftDelete(selectedStudent.id)}
                className="btn-danger"
              >
                Delete Student Record
              </button>
              <button onClick={() => setSelectedStudent(null)} className="btn-secondary">Close</button>
            </div>
          </div>
        </div>
      )}

      {/* Students Table */}
      <table className="data-table">
        <thead>
          <tr>
            <th>Name (Last, First)</th>
            <th>Age</th>
            <th>Date of Birth</th>
            <th>Parent</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.length === 0 ? (
            <tr>
              <td colSpan="6" style={{ textAlign: 'center' }}>
                No student intake records found
              </td>
            </tr>
          ) : (
            students.map(student => (
              <tr key={student.id}>
                <td>{student.last_name}, {student.first_name}</td>
                <td>{student.age || '-'}</td>
                <td>{student.date_of_birth ? new Date(student.date_of_birth).toLocaleDateString() : '-'}</td>
                <td>{student.parent_first_name} {student.parent_last_name}</td>
                <td>{new Date(student.created_at).toLocaleDateString()}</td>
                <td className="actions">
                  <button
                    onClick={() => {
                      setFormsModalStudent(student);
                      setShowFormsModal(true);
                    }}
                    className="btn-edit"
                  >
                    View Forms
                  </button>
                  <button
                    onClick={() => navigate(`/district-admin/edit-student/${student.id}`)}
                    className="btn-secondary"
                    style={{ marginLeft: '0.5rem' }}
                  >
                    Edit Forms
                  </button>
                  <button
                    onClick={() => handleSoftDelete(student.id)}
                    className="btn-danger"
                    style={{ marginLeft: '0.5rem' }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {/* Student Forms Modal */}
      {showFormsModal && formsModalStudent && (
        <StudentFormsModal
          student={formsModalStudent}
          onClose={() => {
            setShowFormsModal(false);
            setFormsModalStudent(null);
          }}
        />
      )}
    </div>
  );
};

export default ViewStudents;
